import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

export interface AppTabItem {
  id: string;
  label: string;
  translateLabel?: boolean;
  icon?: string;
  count?: number;
}

/** Usage: bind tabs and activeId, then handle tabSelected to switch the view. */
@Component({
  selector: 'app-tab-bar',
  templateUrl: './app-tab-bar.component.html',
  styleUrls: ['./app-tab-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppTabBarComponent {
  @Input() tabs: AppTabItem[] = [];
  @Input() activeId = '';
  @Input() ariaLabel = 'Sections';
  @Input() variant: 'default' | 'compact' = 'default';
  @Output() tabSelected = new EventEmitter<string>();

  trackByTabId(index: number, tab: AppTabItem): string {
    return tab.id;
  }

  selectTab(tab: AppTabItem): void {
    this.tabSelected.emit(tab.id);
  }
}
